// @ts-nocheck
// Prevent multiple initializations
if (!window.__dutiesPopupInitialized) {
  window.__dutiesPopupInitialized = true;
  
  // Testing helpers - Available in console as window.dutiesPopupTest
  // Commented out for production - uncomment for testing/debugging
  /*
  window.dutiesPopupTest = {
    clearAcknowledgement: async function() {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { duties_acknowledged: '' }
          })
        });
        await response.json();
        setTimeout(() => location.reload(), 500);
      } catch (error) {
        console.error('Error clearing acknowledgement:', error);
      }
    },
    
    setAcknowledgement: async function() {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { duties_acknowledged: 'true' }
          })
        });
        await response.json();
        setTimeout(() => location.reload(), 500);
      } catch (error) {
        console.error('Error setting acknowledgement:', error);
      }
    },
    
    checkStatus: async function() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        console.log('Cart attributes:', cart.attributes);
        console.log('duties_acknowledged:', cart.attributes?.duties_acknowledged);
        return cart.attributes?.duties_acknowledged;
      } catch (error) {
        console.error('Error checking status:', error);
      }
    }
  };
  */
  
  // Shared functions that can be called from anywhere
  let attachButtonListeners, updateButtonStates, checkAcknowledgement;
  
  function initDutiesPopup() {
    // Wait for dialog-component to be defined
    customElements.whenDefined('dialog-component').then(() => {
      const dialogComponent = document.querySelector('dialog-component.popup-link');
      const acknowledgeBtn = document.getElementById('acknowledge-btn');
      const closePopupBtn = document.getElementById('close-popup');
      const dutiesCheckbox = document.getElementById('duties-checkbox');

      if (!dialogComponent) {
        return;
      }

      // Helper Functions
      function showPopup() {
        dialogComponent.showDialog();
        
        // Reset checkbox and button state when popup opens
        if (dutiesCheckbox && acknowledgeBtn) {
          dutiesCheckbox.checked = false;
          acknowledgeBtn.disabled = true;
        }
      }

      function hidePopup() {
        dialogComponent.closeDialog();
      }

      checkAcknowledgement = async function() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          return cart.attributes?.duties_acknowledged === 'true';
        } catch (error) {
          console.error('Error checking acknowledgement:', error);
          return false;
        }
      };

      updateButtonStates = function(acknowledged) {
        // Regular checkout buttons - don't disable them (so clicks still fire)
        // Instead, use visual styling and the click handler will block if not acknowledged
        const buttons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
        
        buttons.forEach((btn) => {
          if (acknowledged) {
            btn.removeAttribute('data-duties-blocked');
            btn.style.opacity = '';
            btn.style.cursor = '';
          } else {
            btn.setAttribute('data-duties-blocked', 'true');
            if (!btn.classList.contains('cart__checkout-button')) {
              btn.style.opacity = '0.5';
              btn.style.cursor = 'not-allowed';
            }
          }
        });
        
        // Hide/show additional checkout button containers
        const additionalCheckoutContainers = document.querySelectorAll('.additional-checkout-buttons');
        additionalCheckoutContainers.forEach((container) => {
          container.style.display = acknowledged ? '' : 'none';
        });
        
        // Also hide individual Shopify payment buttons as fallback
        const shopifyPaymentButtons = document.querySelectorAll('.shopify-payment-button');
        shopifyPaymentButtons.forEach((btn) => {
          btn.style.display = acknowledged ? '' : 'none';
        });
      };
      
      attachButtonListeners = function() {
        const buttons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
        
        buttons.forEach((button) => {
          // Mark button as having our listener
          if (button.dataset.dutiesListenerAttached) {
            return;
          }
          
          button.dataset.dutiesListenerAttached = 'true';
          
          const handler = async (e) => {
            // Always prevent default first to stop form submission while we check
            e.preventDefault();
            e.stopImmediatePropagation();
            
            const acknowledged = await checkAcknowledgement();
            
            if (acknowledged) {
              // Manually submit to checkout
              window.location.href = '/checkout';
            } else {
              showPopup();
            }
          };
          
          button.addEventListener('click', handler, true);
        });
      };
      
      // Check acknowledgement and set up button management (only if buttons exist)
      const checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
      
      if (checkoutButtons.length > 0) {
        checkAcknowledgement().then(acknowledged => {
          updateButtonStates(acknowledged);
          
          // Only auto-show popup on /cart page, not on other pages (e.g., cart drawer)
          const isCartPage = window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart/');
          
          // Show popup on page load if not acknowledged AND on cart page
          if (!acknowledged && isCartPage) {
            setTimeout(() => {
              showPopup();
            }, 500);
          }
        });

        attachButtonListeners();
      }

      // Enable/disable acknowledge button based on checkbox
      if (dutiesCheckbox && acknowledgeBtn) {
        dutiesCheckbox.addEventListener('change', () => {
          acknowledgeBtn.disabled = !dutiesCheckbox.checked;
        });
      }

      if (acknowledgeBtn) {
        acknowledgeBtn.addEventListener('click', async () => {
          // Double-check checkbox is ticked
          if (dutiesCheckbox && !dutiesCheckbox.checked) {
            return;
          }

          await saveAcknowledgement();
          hidePopup();
          
          // Reset checkbox for next time
          if (dutiesCheckbox) {
            dutiesCheckbox.checked = false;
            acknowledgeBtn.disabled = true;
          }
          
          // Enable checkout buttons and show express payment options
          updateButtonStates(true);
        });
      }

      if (closePopupBtn) {
        closePopupBtn.addEventListener('click', () => {
          hidePopup();
        });
      }

      async function saveAcknowledgement() {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: { duties_acknowledged: 'true' }
            })
          });
        } catch (error) {
          console.error('Error saving acknowledgement:', error);
        }
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDutiesPopup);
  } else {
    initDutiesPopup();
  }
  
  // Track if we're currently updating to prevent observer loops
  let isUpdatingButtonStates = false;
  
  // Listen for morphing events on cart items component
  let morphTimeout;
  
  const cartObserver = new MutationObserver((mutations) => {
    // Skip mutations that happen during our own updates
    if (isUpdatingButtonStates) return;
    
    // Check for cart-related changes OR checkout button additions
    const cartItemsChanges = mutations.filter(m => {
      const target = m.target;
      
      // Check if a checkout button was added
      if (m.type === 'childList' && m.addedNodes.length > 0) {
        for (let node of m.addedNodes) {
          if (node.nodeType === 1) { // Element node
            if (node.matches?.('[name="checkout"], .cart__checkout-button') ||
                node.querySelector?.('[name="checkout"], .cart__checkout-button')) {
              return true;
            }
          }
        }
      }
      
      return target.classList && (
        target.classList.contains('cart-items-component') ||
        target.classList.contains('cart__ctas') ||
        target.closest?.('.cart-items-component')
      );
    });
    
    if (cartItemsChanges.length > 0) {
      // Clear previous timeout to debounce rapid mutations
      clearTimeout(morphTimeout);
      
      // After morphing completes, restore button states and reattach listeners
      morphTimeout = setTimeout(async () => {
        // Safety check: ensure functions are defined (dialog-component might not be ready yet)
        if (typeof attachButtonListeners !== 'function' || typeof checkAcknowledgement !== 'function' || typeof updateButtonStates !== 'function') {
          // If functions aren't ready, wait for dialog-component and try again
          customElements.whenDefined('dialog-component').then(() => {
            setTimeout(async () => {
              if (typeof attachButtonListeners === 'function' && typeof checkAcknowledgement === 'function' && typeof updateButtonStates === 'function') {
                const checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
                checkoutButtons.forEach(btn => delete btn.dataset.dutiesListenerAttached);
                attachButtonListeners();
                
                isUpdatingButtonStates = true;
                const acknowledged = await checkAcknowledgement();
                updateButtonStates(acknowledged);
                setTimeout(() => { isUpdatingButtonStates = false; }, 100);
              }
            }, 200);
          });
          return;
        }
        
        const checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
        
        // Check if any buttons don't have listeners (either new or replaced)
        const needsReattach = checkoutButtons.length > 0 && Array.from(checkoutButtons).some(btn => !btn.dataset.dutiesListenerAttached);
        
        if (needsReattach) {
          // Remove all markers so attachButtonListeners will reattach
          checkoutButtons.forEach(btn => delete btn.dataset.dutiesListenerAttached);
          attachButtonListeners();
        }
        
        // Restore correct button state
        isUpdatingButtonStates = true;
        const acknowledged = await checkAcknowledgement();
        updateButtonStates(acknowledged);
        
        // Small delay before re-enabling observer
        setTimeout(() => {
          isUpdatingButtonStates = false;
        }, 100);
      }, 150);
    }
  });
  
  if (document.body) {
    cartObserver.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });
  }
}
